import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit, inject } from '@angular/core';
import { UserData } from '@riise/shared/utils/constants/users';

import { CryptoService } from '@riise/core/services/crypto/crypto.service';
import { TranslateService } from '@ngx-translate/core';



@Component({
  selector: 'app-space',

    imports: [CommonModule, TranslateModule, RouterModule, ReactiveFormsModule, FormsModule, NgSelectModule, NgScrollbarModule, NgbModule],
    templateUrl: './space.component.html',
    styleUrl: './space.component.scss'
})
export class SpaceComponent implements OnInit {
  private userData = inject(UserData);

  private translateService = inject(TranslateService);
  private crypto = inject(CryptoService);


  message: any;
  space: any = Number(this.userData?.space);
  roleName: any = String(this.userData?.roleName);
  index: any = localStorage.getItem('index');
  flags: any = this.userData?.flags



  private readonly spaceMessages: { [key: string]: string } = {
    '1': 'Espace administrateur',
    '2': 'Espace',
    '3': 'Espace apporteur',
    '4': 'Espace',
    '5': '',
    '6': 'Espace client',
    '7': 'Espace assureur',
    '8': 'Espace visiteur'
  };

  ngOnInit() {
    this.setMessage();
  }



  private setMessage() {
    const messageKey = this.spaceMessages[this.space];
    if (this.space === 2 || this.space === 4) {
        const flagName = this.getFlagName();
        this.message = this.translateService.instant(messageKey) +' '+ flagName
    } else {
        this.message = this.translateService.instant(messageKey);
    }
  }



  private getFlagName(): string {
    const flag = this.flags[this.index];
    const name = flag?.roles[0]?.flagsName
    return name ? name.toLowerCase() : '';
  }







}
